//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { AttendanceOptionsDisplayItem } from './AttendanceOptionsDisplayItem';

export class AttendanceOptionsSummaryDisplayItem extends ItemBase {
    AttendanceID: string | null = null;
    AttendanceOptions: AttendanceOptionsDisplayItem | null = null;

    constructor(initializer?: Partial<AttendanceOptionsSummaryDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "AttendanceOptionsSummaryDisplayItem";
}
